module.exports = __webpack_public_path__ + "static/year2001-75922d5c8517de119de2031393a264a2.jpg";